export { ResetPasswordComponent } from './reset-password/reset-password.component';
export { ChangePasswordComponent } from './change-password/change-password.component';